import { API } from '../../../vendor/api';
import { actionTypes } from '../constants';
import { addToast } from '../../core/actions';
import { ToastType } from '../../core/constants';
export const getExtensionsList = () => async (dispatch, getState) => {
    const extensionsMeta = await API.extensionsAdmin.getAll();
    dispatch({
        type: actionTypes.GET_EXTENSIONS_LIST,
        payload: extensionsMeta,
    });
};
export const getExtensionById = (id) => async (dispatch, getState) => {
    const extensionsMeta = await API.extensionsAdmin.getExtensionById(id);
    dispatch({
        type: actionTypes.GET_EXTENSIONS_BY_ID,
        payload: extensionsMeta,
    });
};
// todo add comment
export const deleteExtension = (id) => async (dispatch, getState) => {
    try {
        await API.extensionsAdmin.deleteExtension({ id });
        dispatch(addToast(ToastType.success, 'Extension successfully deleted.'));
    }
    catch (errorMessage) {
        dispatch(addToast(ToastType.error, errorMessage, 5000));
    }
    finally {
        dispatch(getExtensionsList());
    }
};
export const createExtension = (data) => async (dispatch, getState) => {
    try {
        await API.extensionsAdmin.createExtension(data);
        dispatch(addToast(ToastType.success, 'Extension successfully created.'));
    }
    catch (errorMessage) {
        dispatch(addToast(ToastType.error, errorMessage, 5000));
    }
    finally {
        dispatch(getExtensionsList());
    }
};
export const updateExtension = (data) => async (dispatch, getState) => {
    try {
        await API.extensionsAdmin.updateExtension(data);
        dispatch(addToast(ToastType.success, 'Extension successfully updated.'));
    }
    catch (errorMessage) {
        dispatch(addToast(ToastType.error, errorMessage, 5000));
    }
    finally {
        dispatch(getExtensionsList());
    }
};
export const clearExtension = () => async (dispatch, getState) => {
    dispatch({
        type: actionTypes.CLEAR_EXTENSION,
    });
};
